// src/pages/CoachPage.js
import React, { useState } from "react";
import { useAuth } from "../hooks/useAuth";
import { Link } from "react-router-dom";
import "./SimplePage.css";

const API = process.env.REACT_APP_API_URL || "http://localhost:3001";

const DEMON_PROMPTS = {
  default: (demonName, perks) =>
    `Tu es le Coach Démoniaque de Takkyu Oni — un entraîneur de tennis de table qui est lui-même un démon. 
    Tu donnes des conseils brutalement honnêtes, légèrement farfelus, avec une touche d'humour démoniaque japonais.
    Le joueur est un "${demonName}" avec ces perks: ${perks?.join(", ") || "inconnus"}.
    Analyse cette vidéo et donne des conseils en accord avec sa nature démoniaque.
    Tes conseils doivent être techniques ET dans le lore (ex: "Ton Turtle Oni refuse de bouger les pieds — il attend que l'adversaire vienne à lui. C'est démoniaquement patient mais tactiquement suicidaire en attaque.").
    Structure: 3-4 observations courtes + 2 conseils prioritaires.`,
};

export default function CoachPage() {
  const { user, profile } = useAuth();
  const [url, setUrl]         = useState("");
  const [loading, setLoading] = useState(false);
  const [result, setResult]   = useState(null);
  const [error, setError]     = useState(null);

  const demon = profile?.demon;
  const demonName = demon?.oni?.name || "Oni Inconnu";
  const perks = demon?.perks || [];

  const analyze = async () => {
    if (!url.trim()) return;
    setError(null); setResult(null); setLoading(true);
    try {
      const prompt = DEMON_PROMPTS.default(demonName, perks);
      const res = await fetch(`${API}/analyze`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ type: "youtube", url: url.trim(), prompt, player: "joueur principal", preset: "full" }),
      });
      if (!res.ok) throw new Error(`Erreur serveur ${res.status}`);
      const data = await res.json();
      setResult(data.result);
    } catch(e) {
      setError(e.message);
    } finally {
      setLoading(false);
    }
  };

  if (!user) return (
    <div className="simple-page">
      <div className="section" style={{paddingTop:"8rem", textAlign:"center"}}>
        <span className="section-eyebrow">Coach · 悪魔コーチ</span>
        <h2 className="section-title">Coach Démoniaque</h2>
        <div className="divider divider-center"/>
        <p style={{color:"var(--ash)", marginBottom:"2rem"}}>Connecte-toi pour accéder au coach.</p>
        <Link to="/auth" className="btn btn-primary">ENTRER →</Link>
      </div>
    </div>
  );

  return (
    <div className="simple-page">
      <div className="section" style={{paddingTop:"8rem"}}>
        <span className="section-eyebrow">悪魔コーチ · Coach Démoniaque</span>
        <h1 className="section-title">Le Coach<br/>Démoniaque</h1>
        <div className="divider"/>
        {demon && (
          <div className="coach-demon-badge">
            <span>{demon.oni?.emoji}</span>
            <div>
              <p style={{fontSize:"0.7rem", color:"var(--ash)", letterSpacing:"2px"}}>TON DÉMON ANALYSE</p>
              <p style={{color:"var(--blood)", fontFamily:"var(--font-kanji)", fontSize:"1.2rem"}}>{demonName}</p>
            </div>
          </div>
        )}
        <p style={{color:"var(--ash)", fontSize:"0.82rem", lineHeight:2, margin:"1.5rem 0"}}>
          Colle un lien YouTube de ton entraînement. Le coach démoniaque analyse ta vidéo et te donne des conseils dans le lore de ton Oni.
        </p>

        <div className="coach-form">
          <div className="field">
            <label>URL YOUTUBE</label>
            <input type="text" value={url} onChange={e=>setUrl(e.target.value)} placeholder="https://youtube.com/watch?v=..." />
          </div>
          <button className="btn btn-primary" onClick={analyze} disabled={loading || !url.trim()}>
            {loading ? <><span className="spinner"/> INVOCATION EN COURS...</> : "ANALYSER →"}
          </button>
        </div>

        {error && <div className="coach-error">⚠ {error}</div>}

        {result && (
          <div className="coach-result">
            <div className="coach-result-header">
              <span>👹</span>
              <p>Le {demonName} a parlé</p>
            </div>
            {result.points_forts?.length > 0 && (
              <div className="coach-section">
                <p className="coach-section-title" style={{color:"var(--gold)"}}>✦ CE QUI EST DÉMONIAQUEMENT BON</p>
                {result.points_forts.map((p,i) => <p key={i} className="coach-point pos">{p}</p>)}
              </div>
            )}
            {result.defauts?.length > 0 && (
              <div className="coach-section">
                <p className="coach-section-title" style={{color:"var(--blood)"}}>☠ LES FAILLES DE TON ONI</p>
                {result.defauts.map((d,i) => (
                  <div key={i} className="coach-defaut">
                    <p className="defaut-t">{d.titre || d}</p>
                    {d.detail && <p className="defaut-d">{d.detail}</p>}
                    {d.conseil && <p className="defaut-c">→ {d.conseil}</p>}
                  </div>
                ))}
              </div>
            )}
            {result.note_globale && (
              <div className="coach-global">
                <p className="coach-section-title">◈ VERDICT DÉMONIAQUE</p>
                <p className="coach-global-text">"{result.note_globale}"</p>
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );
}
